// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3gtR6","title":"Images45_title__1R2KJ","images":"Images45_images__1Q-3c"};